import React, { Component } from 'react';

class Login extends Component {

    constructor(props) {
        super(props);
    }
   
    render() {
        return (
            <div style={{ width: '100vw', height: '100vh' }}>
                <div style={{ display: 'flex', height: 'calc(100% - 36px)', justifyContent: 'center',
                alignItems: 'center', backgroundColor: '#F5F6FF', margin: 18 }}>
                    <div style={{ cursor: 'pointer' }}
                    onClick={()=>{ window.location.href='https://api.voteism.org/user/auth/google' }}>
                        <img src={require('./assets/logo.png')} width={'150px'} alt='VOTEism' />
                    </div>
                </div>
            </div>
        );
    }
}

export default Login;